<template>
    <div >
        <div v-if="extra.old">
            <span class="timeline-key">Visa Requested Period  </span>: {{extra.visa_requested_from}} - {{extra.visa_requested_to}}<br>
        </div>
        <div v-else>
<!--            {{extra}}-->
            <span class="timeline-key">Visa Type </span>: {{extra.visa_type}}<br>
            <span class="timeline-key" v-if="extra.visa_type_condition">Visa condition </span>: {{extra.visa_type_condition.name}}<br>
            <span class="timeline-key">Days </span> : {{days}}  <br>
            <span class="timeline-key">Cost </span> : {{cost}} USD  <br>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Applied",
        props: ['extra', 'days','cost'],
    }
</script>
